import React, {useState} from 'react';
import FCSelect from "../../../FCObjets/Form/FCSelect";

export interface InterfaceAccountUser {
    firstname: string;
    lastname: string;
    contactEmail: string;
    phoneNumber: string;
    civility: string;
    titleJob: string;
    urlCV: string;
}

export type AccountUserProps = {
    handlerChange: (dataUser: InterfaceAccountUser) => void;
    data: InterfaceAccountUser;
    fieldErrors?: Record<string, string>;
}

const FormAccountUser: React.FC<AccountUserProps> = ({handlerChange, data, fieldErrors = {}}) => {

    const [dataUser, setDataUser] = useState<InterfaceAccountUser>(data);

    const eventChange = (key: keyof InterfaceAccountUser, value: string) => {
        const v: InterfaceAccountUser = {...dataUser, [key]: value};
        setDataUser(v);
        handlerChange(v);
    };

    return (
        <>
            <div className="configField">
                <label>Civilité</label>
                <FCSelect
                    options={[
                        {value: "Monsieur", label: "Monsieur"},
                        {value: "Madame", label: "Madame"},
                        {value: "Non binaire", label: "Non binaire"},
                    ]}
                    value={dataUser.civility}
                    onChange={(v) => eventChange("civility", String(v))}
                />
            </div>

            <div className="configRow">
                <div className={`configField${fieldErrors.firstname ? " configField--error" : ""}`}>
                    <label htmlFor="prenom">Prénom</label>
                    <input id="prenom" type="text" value={dataUser.firstname}
                           onChange={(e) => eventChange("firstname", e.target.value)}/>
                    {fieldErrors.firstname && <span className="fcaFieldError">{fieldErrors.firstname}</span>}
                </div>
                <div className={`configField${fieldErrors.lastname ? " configField--error" : ""}`}>
                    <label htmlFor="nom">Nom</label>
                    <input id="nom" type="text" value={dataUser.lastname}
                           onChange={(e) => eventChange("lastname", e.target.value)}/>
                    {fieldErrors.lastname && <span className="fcaFieldError">{fieldErrors.lastname}</span>}
                </div>
            </div>

            <div className="configRow">
                <div className={`configField configFieldIcon${fieldErrors.contactEmail ? " configField--error" : ""}`}>
                    <label htmlFor="email">Email</label>
                    <span className="material-symbols-outlined">mail</span>
                    <input id="email" type="email" value={dataUser.contactEmail}
                           placeholder="contact@exemple.fr"
                           onChange={(e) => eventChange("contactEmail", e.target.value)}/>
                    {fieldErrors.contactEmail && <span className="fcaFieldError">{fieldErrors.contactEmail}</span>}
                </div>
                <div className="configField configFieldIcon">
                    <label htmlFor="phone">Numéro de téléphone</label>
                    <span className="material-symbols-outlined">phone</span>
                    <input id="phone" type="tel" value={dataUser.phoneNumber}
                           placeholder="+33 1 23 45 67 89"
                           onChange={(e) => eventChange("phoneNumber", e.target.value)}/>
                </div>
            </div>

            <div className="configField">
                <label htmlFor="titlejob">Statut</label>
                <input id="titlejob" type="text" value={dataUser.titleJob}
                       placeholder="Ingénieur Full-Stack"
                       onChange={(e) => eventChange("titleJob", e.target.value)}/>
            </div>

            <div className="configField configFieldIcon">
                <label htmlFor="urlCV">URL CV</label>
                <span className="material-symbols-outlined">link</span>
                <input id="urlCV" type="text" value={dataUser.urlCV}
                       placeholder="https://mon-portfolio.com"
                       onChange={(e) => eventChange("urlCV", e.target.value)}/>
            </div>
        </>
    );
};

export default FormAccountUser;
